import { arrayOf, shape, string } from 'prop-types'

export const trustBoxLink = shape({
  id: string.isRequired,
  alt: string.isRequired,
  href: string,
  hidden: string,
})

export const trustBoxLinkDefaultProps = shape({
  href: null,
  hidden: null,
})

export const trustBoxLinks = arrayOf(trustBoxLink)
export const trustBoxLinksDefaultProps = arrayOf(trustBoxLinkDefaultProps)
